export const EVENT_TRACKING_CATEGORIES = {
  INBOX_PAGE: 'InboxPage',
  MULTI_FAMILY_LEAD_MANAGEMENT: 'MultiFamilyLeadManagement',
  LEAD_MANAGEMENT_PAGE: 'LeadManagementPage',
  SATELLITE: 'Satellite',
} as const;
